<template>
  <div>

    <HeaderMain />

    <!-- ПОЛУЧИТЕ ЗАЙМ БЕСПЛАТНО -->
    <div class="section color">
      <div data-w-id="8a817dec-33d8-ba64-0999-5e0ddc2f3a81" class="container one w-container pb-0 pt-0" style="border-bottom: none;">
        <div class="w-layout-grid grid-2-colum" style="grid-column-gap: unset;">
          <!-- синий блок "получите займ бесплатно" -->
          <div id="w-node-_4f1dd468-2e2a-a103-3ef7-edd160e2b38a-8870dddc" class="grid-colum left w-100"
               style="
               padding: 25px;
               padding-bottom: 35px;
               border-radius: unset;
               background-color: var(--accent-2);
               position: relative;
               overflow: hidden;
            ">
            <div class="w-layout-vflex tittle"
                 style="
                 z-index: 1;
                 justify-content: space-between;"
            >
              <div class="w-layout-vflex heading-title">
                <h1 class="heading" style="color: #fff;">Получите <br>первый займ<br>босплатнооо!</h1>
              </div>
              <div class="w-layout-vflex flex-good"
                   style="flex-flow: row;"
              >
                <div>
                  <img height="30px" alt="visa" src="../../../../../public/images/visa.svg">
                </div>
                <div>
                  <img height="30px" alt="mir" src="../../../../../public/images/mir.svg">
                </div>
                <div>
                  <img height="30px" alt="mastercard" src="../../../../../public/images/mastercard.svg">
                </div>
              </div>
            </div>

            <!-- Картинка в углу -->
            <img src="../../../../../public/images/money.png" alt="money"
                 style="position: absolute;
                 bottom: -18%;
                 right: -10%;"
                 class="money-width"
            >
          </div>
          <!-- блок с калькулятором -->
          <div id="w-node-_8a817dec-33d8-ba64-0999-5e0ddc2f3a91-8870dddc" class="grid-colum right">
            <div class="calculators color-2">
              <div class="flex-calculate">
                <div class="calculate-block one" style="margin-bottom: 0;">
                  <div class="sum-top between direction-row">
                    <div class="text-mini black" style="line-height: 100%;">Сумма займа</div>
                    <div class="sum-result"><span id="calculator_sum" class="sum">10 000</span> <span class="rub">₽</span></div>
                  </div>
                  <div class="wrapper-block">
                    <div class="range-slaider w-embed">
                      <div class="calculator_bottom-slider slider-styled" id="slider-sum"></div>
                    </div>
                  </div>
                  <div class="alculator-results-block between direction-adaptive align-items-start" style="margin-top: 10px;">
                    <div>
                      <div class="text-mini">5000₽ - 30000₽</div>
                    </div>
                    <div style="display: flex; gap: 10px;">
                        <div class="text-mini black">Возвращаете</div>
                        <div class="result-sum">
                          <div class="text-mini sum red"><span id="sale-price" class="sale-prices">36 300</span> ₽</div>
                          <div class="text-mini sum green"><span id="price" class="price">30 000</span> ₽</div>
                        </div>
                    </div>
                  </div>
                </div>
                <div class="calculate-block right" style="margin-bottom: 0;">
                  <div class="sum-top between direction-row">
                    <div class="text-mini black" style="line-height: 100%;">Срок займа</div>
                    <div class="sum-result"><span id="calculator_date" class="day-namber">91</span> дней</div>
                  </div>
                  <div id="w-node-_94cd84f4-706f-fb9f-9827-6f4f6393e98b-8870dddc" class="wrapper-block">
                    <div class="range-slaider w-embed">
                      <div class="calculator_bottom-slider" id="slider-period"></div>
                    </div>
                  </div>
                  <div class="alculator-results-block between direction-adaptive align-items-start" style="margin-top: 10px;">
                    <div>
                      <div class="text-mini">91-365 дней</div>
                    </div>
                    <div style="display: flex; gap: 10px;">
                      <div class="alculator-results-block">
                        <div class="text-mini black" style="line-height: 100%;">Дата возврата</div>
                        <div id="date" class="text-mini sum">24.10.2023</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-layout-hflex flex-item-best">
                <a id="openLabel" @click="clickOpenLabel1" class="button-bust w-button">Оформить заявку</a>
                <link rel="prerender" @click="clickOpenLabel1">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- КОЛОБОК В ТВОЁМ ТЕЛЕФОНЕ -->
    <div class="section color">
      <div data-w-id="8a817dec-33d8-ba64-0999-5e0ddc2f3a81" class="container one w-container pt-0" style="border-bottom: none;">
        <div class="w-layout-grid grid-1-colum" style="grid-column-gap: unset;">
          <div id="w-node-_4f1dd468-2e2a-a103-3ef7-edd160e2b38a-8870dddc" class="grid-colum left w-100"
               style="
               padding: 25px 30px 35px 25px;
               border-radius: unset;
               background: linear-gradient(to bottom right, #6F7B8F, #202329);">
            <div class="w-layout-vflex tittle"
                 style="justify-content: space-between;"
            >
              <div class="w-layout-vflex heading-title w-100">
                <div class="flex w-100 space-between" style="gap: 10px;">
                  <h1 class="heading" style="color: #fff;">Колобок в твоём<br>телефоне</h1>
                  <h1 class="text-mini white" style="color: #fff;">Установите наше приложение<br>и получите деньги за пару кликов</h1>
                </div>
              </div>

              <!-- блок разных вариантов установки, появляется на мобилках -->
              <div class="w-layout-vflex flex-good hidden-install"
                   style="
                       margin-bottom: 60px;
                       align-items: end;
                       flex-flow: row;
                       justify-content: space-around;"
              >
                <div>
                  <img height="60px" alt="googleplay" src="../../../../../public/images/google_play.svg">
                </div>
              </div>

              <div class="w-layout-vflex flex-good "
                   style="
                       overflow: initial;
                       align-items: end;
                       flex-flow: row;
                       justify-content: space-between;"
              >
                <div class="install-image">
                  <img height="60px" alt="ruble" src="../../../../../public/images/ruble.svg">
                </div>
                <div>
                  <img
                      style="transform: translate(50px, 80px); margin-top: -100px;"
                      class="w-100 iphone"
                      alt="phone" src="../../../../../public/images/iphone.png">
                </div>
                <div style="width: 40%; max-width: 300px; text-align: right;" class="install-image">
                  <img style="max-width: 300px;" alt="install" src="../../../../../public/images/google_play.svg">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ТВОЙ ПОМОЩНИК НА КАЖДЫЙ ДЕНЬ -->
    <div class="section color">
      <div id="Pochemu" data-w-id="8a817dec-33d8-ba64-0999-5e0ddc2f3a81" class="container one w-container" style="border-bottom: none;">
        <div class="w-layout-grid grid-2-colum mt-0" style="grid-column-gap: unset;">
          <div id="w-node-_4f1dd468-2e2a-a103-3ef7-edd160e2b38a-8870dddc" class="grid-colum left w-100"
               style="
               padding: 25px;
               padding-bottom: 35px;
               border-radius: unset;
            ">
            <div class="w-layout-vflex item _1">
              <div class="text-mini semibold">Надёжность</div>
              <h1 class="heading">Твой помощник на каждый день</h1>
            </div>


            <!-- картиночка сообщения с тектом внутри -->
            <div class="w-100">
              <div class="message">
                <h1 class="heading h2" style="color: #fff;">Решение принимает робот, а не человек.<br>А значит вы получаете деньги быстро</h1>
                <div class="w-layout-hflex flex-item-best">
                  <a @click="clickOpenLabel1" class="button-bust w-button">Оформить заявку</a>
                  <link rel="prerender" @click="clickOpenLabel1">
                </div>
              </div>
            </div>

          </div>
          <div id="w-node-ab6d8353-038f-d5eb-c2b5-ebdaefa956f0-8870dddc" class="item _2 grid-colum left w-100" style="
               padding: 25px;
               padding-bottom: 35px;
               border-radius: unset;
            ">
            <div class="text-mini semibold">Преимущества</div>
            <h2 class="heading h2">Помогаем тогда, когда это нужно</h2>

            <div class="w-layout-hflex item-row gap-1">
                <div class="text-classic">
                  <img class="img-80" src="../../../../../public/images/helper/1.svg" alt="helper1">
                </div>
                <div class="w-layout-vflex item-col center gap-2">
                  <h2 class="heading h3">Работаем для вас 24/7</h2>
                  <div class="text-mini semibold">Без выходных и праздничных дней</div>
                </div>
            </div>

            <div class="w-layout-hflex item-row gap-1">
              <div class="text-classic">
                <img class="img-80" src="../../../../../public/images/helper/2.svg" alt="helper2">
              </div>
              <div class="w-layout-vflex item-col center gap-2">
                <h2 class="heading h3">Ваши данные надёжно защищены</h2>
                <div class="text-mini semibold">Третьи лица никогда их не получат без вашего ведома</div>
              </div>
            </div>

            <div class="w-layout-hflex item-row gap-1">
              <div class="text-classic">
                <img class="img-80" src="../../../../../public/images/helper/3.svg" alt="helper3">
              </div>
              <div class="w-layout-vflex item-col center gap-2">
                <h2 class="heading h3">Не звоним родственникам и работодателю</h2>
                <div class="text-mini semibold">Они никогда не узнают, что бы обращались к нам</div>
              </div>
            </div>

            <div class="w-layout-hflex item-row gap-1">
              <div class="text-classic">
                <img class="img-80" src="../../../../../public/images/helper/4.svg" alt="helper4">
              </div>
              <div class="w-layout-vflex item-col center gap-2">
                <h2 class="heading h3">Продление займа</h2>
                <div class="text-mini semibold">Перенесите срок возврата, если не успеваете погасить полностью</div>
              </div>
            </div>

          </div>
        </div>
        <hr class="bold mt-10 mx-25">
      </div>
    </div>

    <!-- КАК ПОЛУЧИТЬ ЗАЕМ -->
    <div class="section color">
      <div data-w-id="8a817dec-33d8-ba64-0999-5e0ddc2f3a81" class="container one w-container pt-0 pb-0" style="border-bottom: none;">
        <div class="w-layout-grid grid-2-colum mt-0" style="grid-column-gap: unset;">
          <div id="w-node-_4f1dd468-2e2a-a103-3ef7-edd160e2b38a-8870dddc" class="grid-colum left w-100 gray-container"
               style="
               padding: 25px;
               padding-bottom: 35px;
               border-radius: unset;
            ">
            <div class="w-layout-vflex item _1 w-100">
              <div class="text-mini semibold">Деньги на карту</div>
              <div class="w-100">
                <h1 class="heading">Как получить заём</h1>
                <div class="w-100 flex justify-end">
                  <img style="max-width: 70%; position: relative; right: -25px;" alt="money-2" src="../../../../../public/images/money_2.png">
                </div>
              </div>
            </div>

            <div class="w-layout-hflex flex-item-best w-text">
              <a @click="goToGetLoan" class="button-bust w-button w-text">Подробнее</a>
            </div>
          </div>
          <!-- инструкция для одобрения займа -->
          <div id="w-node-_8a817dec-33d8-ba64-0999-5e0ddc2f3a91-8870dddc"
               class="grid-colum right"
               style="padding: 25px 25px 35px;">
            <div class="text-mini semibold">Инструкция</div>
            <h2 class="heading h2">Для одобрения займа </h2>

            <div class="w-layout-hflex item-row gap-1">
              <div class="text-classic">
                <img class="img-40" src="../../../../../public/images/numbers/1.svg" alt="number1">
              </div>
              <div class="w-layout-vflex item-col center gap-2">
                <h2 class="heading h4">Выберите срок и сумму займа.</h2>
              </div>
            </div>

            <div class="w-layout-hflex item-row gap-1">
              <div class="text-classic">
                <img class="img-40" src="../../../../../public/images/numbers/2.svg" alt="number2">
              </div>
              <div class="w-layout-vflex item-col center gap-2">
                <h2 class="heading h4">Зарегистрируйтесь на сайте. Нажмите кнопку «Получить деньги», введите актуальный номер мобильного телефона и получите пароль в СМС-сообщении, по которому вы авторизуетесь на сайте.</h2>
              </div>
            </div>

            <div class="w-layout-hflex item-row gap-1">
              <div class="text-classic">
                <img class="img-40" src="../../../../../public/images/numbers/3.svg" alt="number3">
              </div>
              <div class="w-layout-vflex item-col center gap-2">
                <h2 class="heading h4">Заполните короткую анкету.</h2>
              </div>
            </div>

            <div class="w-layout-hflex item-row gap-1">
              <div class="text-classic">
                <img class="img-40" src="../../../../../public/images/numbers/4.svg" alt="number4">
              </div>
              <div class="w-layout-vflex item-col center gap-2">
                <h2 class="heading h4">Выберите способ получения займа и добавьте банковскую карту выпущенную на Ваше имя.</h2>
              </div>
            </div>

            <div class="w-layout-hflex item-row gap-1">
              <div class="text-classic">
                <img class="img-40" src="../../../../../public/images/numbers/5.svg" alt="number5">
              </div>
              <div class="w-layout-vflex item-col center gap-2">
                <h2 class="heading h4">Дождитесь решения. Заявки по срочным мини займам онлайн на карту рассматриваются круглосуточно.</h2>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- СПОСОБЫ ПОГАШЕНИЯ ЗАЙМА -->
    <div class="section color">
      <div data-w-id="8a817dec-33d8-ba64-0999-5e0ddc2f3a81" class="container one w-container pt-0 pb-0" style="border-bottom: none;">
        <div class="w-layout-grid grid-1-colum" style="grid-column-gap: unset;">
          <div id="w-node-_4f1dd468-2e2a-a103-3ef7-edd160e2b38a-8870dddc" class="grid-colum left w-100"
               style="
               padding: 25px 30px 35px 25px;
               border-radius: unset;
               background: #CCDEFE;">
            <div class="w-layout-vflex tittle small-gap"
                 style="justify-content: space-between;"
            >
              <div class="w-layout-vflex heading-title w-100">
                <div class="flex w-100 space-between" style="gap: 10px;">
                  <h1 class="heading">Способы погашения <br>займа</h1>
                  <h1 class="text-mini semibold">Онлайн и офлайн оплата</h1>
                </div>
              </div>


              <div class="w-layout-vflex flex-good "
                   style="
                       overflow: initial;
                       align-items: end;
                       flex-flow: row;
                       grid-column-gap: unset;
                       justify-content: center;"
              >
                <div class="center-image-block">
                  <img src="../../../../../public/images/repayment/1.svg" alt="repayment1">
                  <div class="text-mini black height-2">Картой онлайн</div>
                </div>

                <div class="center-image-block">
                  <img src="../../../../../public/images/repayment/2.svg" alt="repayment2">
                  <div class="text-mini black height-2">Терминал «Элекснет»</div>
                </div>

                <div class="center-image-block">
                  <img src="../../../../../public/images/repayment/3.svg" alt="repayment3">
                  <div class="text-mini black height-2">Касса банка</div>
                </div>
              </div>

              <div class="w-layout-vflex flex-good "
                   style="
                       overflow: initial;
                       align-items: end;
                       flex-flow: row;
                       justify-content: space-between;"
              >
                <h2 class="text-mini white bold">Банковской картой,<br>в терминале «Элекснет»<br>или в кассе банка</h2>

                <div class="w-layout-hflex flex-item-best w-text">
                  <a @click="goToReturn" class="button-bust w-button w-text">Подробнее</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ОТЗЫВЫ НАШИХ ПОЛЬЗОВАТЕЛЕЙ -->
    <div class="section color">
      <div data-w-id="8a817dec-33d8-ba64-0999-5e0ddc2f3a81" class="container one w-container pt-0 pb-0" style="border-bottom: none;">
        <div class="w-layout-grid grid-2-colum mt-0" style="grid-column-gap: unset;">

          <div id="w-node-_4f1dd468-2e2a-a103-3ef7-edd160e2b38a-8870dddc" class="grid-colum left w-100 gray-container"
               style="
               padding: 25px;
               padding-bottom: 35px;
               border-radius: unset;
            ">
            <div class="w-layout-vflex item _1 w-100">
              <div class="text-mini semibold">Обратная связь</div>
              <div class="w-100">
                <h1 class="heading">Отзывы наших<br>пользователей</h1>
                <div class="w-100 flex justify-end" style="margin-top: 60px;">
                  <img style="max-width: 70%; position: relative; right: -25px;" alt="money-2" src="../../../../../public/images/reviews.png">
                </div>
              </div>
            </div>

            <div class="w-layout-hflex flex-item-best w-text">
              <a @click="goToReviews" class="button-bust w-button w-text">Все отзывы</a>
            </div>
          </div>

          <div id="w-node-_8a817dec-33d8-ba64-0999-5e0ddc2f3a91-8870dddc"
               class="grid-colum right w-100"
               style="padding: 25px 25px 35px;">

            <div class="w-layout-vflex item _1 w-100">
              <div class="text-mini semibold">Отзывы</div>
              <img src="../../../../../public/images/stars.svg" alt="stars" style="margin-top: 15px; margin-bottom: 15px;">
              <h2 class="heading h2">{{ currentReview.shortReview }}</h2>
              <div class="text-mini semibold">{{ currentReview.name }}</div>

              <h2 class="text-mini white bold" style="margin-top: 0;">
                {{ currentReview.fullReview }}
              </h2>
            </div>

            <div class="w-layout-hflex flex-item-best w-text" style="gap: 20px;">
              <img class="pointer" @click="previousReview" height="60px" alt="ruble" src="../../../../../public/images/previous.svg">
              <img class="pointer" @click="nextReview" height="60px" alt="ruble" src="../../../../../public/images/next.svg">
            </div>
          </div>

        </div>

      </div>
    </div>

    <!-- ВСЕГДА СТРЕМИМСЯ БЫТЬ №1 -->
    <div class="section color">
      <div data-w-id="8a817dec-33d8-ba64-0999-5e0ddc2f3a81" class="container one w-container pt-0 pb-0" style="border-bottom: none;">
        <div class="w-layout-grid grid-2-colum" style="grid-column-gap: unset;">

          <div id="w-node-_4f1dd468-2e2a-a103-3ef7-edd160e2b38a-8870dddc" class="grid-colum left w-100"
               style="
               padding: 25px;
               padding-bottom: 35px;
               border-radius: unset;
               background-color: var(--accent);
               position: relative;
               overflow: hidden;
            ">
            <div class="w-layout-vflex tittle"
                 style="
                 z-index: 1;
                 justify-content: space-between;"
            >
              <div class="w-layout-vflex heading-title">
                <h1 class="heading" style="color: #fff;">Всегда<br>стремимся<br>быть №1</h1>
              </div>
              <div class="w-layout-vflex flex-good"
                   style="max-width: calc(60% - 15px);"
              >
                <h1 class="text-mini white" style="color: #fff;">Всегда стремимся быть лучшими в своей сфере, чтобы оказывать максимально эффективную помощь нашим клиентамю</h1>
              </div>
            </div>

            <!-- Картинка в углу -->
            <img src="../../../../../public/images/cup.png" alt="cup"
                 style="position: absolute;
                 bottom: 0;
                 right: 10px;"
                 class="money-width-small"
            >
          </div>

          <div id="w-node-_8a817dec-33d8-ba64-0999-5e0ddc2f3a91-8870dddc" class="grid-colum right">
            <div class="calculators color">
              <div class="flex-calculate" style="margin-bottom: 50px;">
                <div class="calculate-block one" style="margin-bottom: 0;">

                  <div class="w-layout-hflex item-row gap-1">
                    <div class="text-classic">
                      <img class="img-60" src="../../../../../public/images/number_1/1.svg" alt="number one">
                    </div>
                    <div class="w-layout-vflex item-col center gap-2">
                      <h2 class="heading h3">Топ 20</h2>
                      <div class="text-mini semibold">Вошли в топы МФО всего за год</div>
                    </div>
                  </div>

                </div>
                <div class="calculate-block right" style="margin-bottom: 0;">
                  <div class="w-layout-hflex item-row gap-1">
                    <div class="text-classic">
                      <img class="img-60" src="../../../../../public/images/number_1/2.svg" alt="number one">
                    </div>
                    <div class="w-layout-vflex item-col center gap-2">
                      <h2 class="heading h3">10 000 выдач<br>за месяц</h2>
                      <div class="text-mini semibold">Нам доверяют</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-layout-hflex flex-item-best">
                <a id="openLabel" @click="clickOpenLabel1" class="button-bust w-button">Оформить заявку</a>
                <link rel="prerender" @click="clickOpenLabel1">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- КОЛОБОК В ТВОЁМ ТЕЛЕФОНЕ (2) -->
    <div class="section color">
      <div data-w-id="8a817dec-33d8-ba64-0999-5e0ddc2f3a81" class="container one w-container pt-0" style="border-bottom: none;">
        <div class="w-layout-grid grid-1-colum" style="grid-column-gap: unset;">
          <div id="w-node-_4f1dd468-2e2a-a103-3ef7-edd160e2b38a-8870dddc" class="grid-colum left w-100"
               style="
               position: relative; overflow: hidden;
               padding: 25px 30px 35px 25px;
               border-radius: unset;
               background: linear-gradient(135deg, #005BFA 0%, #005BFA 32%, #CFDCF0 90%);
               background-position: 50% 0;
               background-size: 150% 150%;">
            <div class="w-layout-vflex tittle"
                 style="justify-content: space-between;"
            >
              <div class="w-layout-vflex heading-title w-100" style="z-index: 1;">
                <div class="flex w-100 space-between" style="gap: 10px;">
                  <h1 class="heading" style="color: #fff;">Колобок в твоём<br>телефоне</h1>
                  <img alt="install" src="../../../../../public/images/google_play.svg" class="install-image">
                </div>
              </div>

              <!-- Картинка в углу -->
              <img src="../../../../../public/images/money.png" alt="money"
                   class="money-width-2"
              >

              <!-- блок разных вариантов установки, появляется на мобилках -->
              <div class="w-layout-vflex flex-good hidden-install"
                   style="
                       align-items: end;
                       flex-flow: row;
                       z-index: 2;
                       justify-content: space-around;"
              >
                <div>
                  <img height="60px" alt="googleplay" src="../../../../../public/images/google_play.svg">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- О КОМПАНИИ И ДОКУМЕНТЫ -->
    <div class="section color">
      <div data-w-id="8a817dec-33d8-ba64-0999-5e0ddc2f3a81" class="container one w-container pt-0 pb-0" style="border-bottom: none;">
        <div class="w-layout-grid grid-1-colum" style="grid-column-gap: unset;">

          <div id="w-node-_4f1dd468-2e2a-a103-3ef7-edd160e2b38a-8870dddc" class="grid-colum left w-100 gray-container"
               style="
               padding: 25px;
               padding-bottom: 35px;
               border-radius: unset;
            ">
            <div class="w-layout-vflex item w-100">
              <div class="text-mini semibold">О компании</div>
              <h2 class="heading h2">Колобок: быстрый онлайн-заём</h2>

              <div class="text-mini white">Автоматическая выдача микрозаймов без ошибок и перерывов. Для постоянных
                клиентов — простой доступ к деньгам через личный кабинет.<br><br>
                Получите деньги в любое время суток, даже в праздничные дни за считанные минуты
                на карту или счёт. Безопасно и удобно.</div>
            </div>

            <div class="w-layout-hflex flex-item-best w-text">
              <a @click="goToCompanyPage" class="button-link">Подробнее</a>
            </div>
          </div>

        </div>
      </div>
    </div>

    <Footer />

  </div>
</template>

<script>
import { Footer, HeaderMain } from '/src/app/shared/components';
import loadjs from 'loadjs';

export default {
  name: 'Main',
  data() {
    return {
      slider: null,
      slider2: null,
      currentTime: new Date(),
      reviews: [
        {
          name: 'Алексей',
          shortReview: 'Круто работают ребята',
          fullReview: 'Хотел сделать сюрприз своей жене на день рождения и купить ей долгожданный подарок, но не хватило собственных сбережений. Не знал, что делать, но друг посоветовал воспользоваться услугами микрозайма через один из онлайн-сервисов. Я зарегистрировался на сайте, заполнил заявку и почти сразу получил одобрение от МФО. Процесс получения займа занял всего несколько минут, и уже через 10 минут я получил необходимую сумму на карту.'
        },
        {
          name: 'Мария',
          shortReview: 'Отличный сервис',
          fullReview: 'Оформление прошло быстро и без проблем. Деньги пришли вовремя, что меня очень порадовало. Буду рекомендовать этот сервис всем своим друзьям и знакомым. Очень довольна результатом!'
        },
        {
          name: 'Иван',
          shortReview: 'Рекомендую всем',
          fullReview: 'Очень доволен работой компании. Получил займ буквально за 10 минут. Всё было максимально просто и удобно. Отличная поддержка клиентов и выгодные условия. Буду пользоваться снова при необходимости.'
        },
        {
          name: 'Елена',
          shortReview: 'Лучший выбор',
          fullReview: 'Воспользовалась услугами и осталась очень довольна. Процесс быстрый и удобный, никаких лишних вопросов и бумажной волокиты. Деньги пришли моментально, как и обещали. Сервис на высоте!'
        },
        {
          name: 'Дмитрий',
          shortReview: 'Надёжно и быстро',
          fullReview: 'Не думал, что всё будет так просто. Заполнил заявку и сразу получил деньги на карту. Вся процедура заняла буквально несколько минут. Очень удобно, особенно когда срочно нужны деньги. Рекомендую!'
        }
      ],
      currentIndex: 0
    };
  },
  components: {
    Footer,
    HeaderMain
  },
  created() {
    setInterval(() => {
      this.currentTime = new Date();
    }, 60000); // Каждую минуту
  },
  computed: {
    currentReview() {
      return this.reviews[this.currentIndex];
    },
    futureTime() {
      // Создаем новый объект Date, добавляя 10 минут к текущему времени
      const futureTime = new Date(this.currentTime.getTime() + 10 * 60000); // 10 минут в миллисекундах

      // Форматируем время в формат hh:mm
      const hours = ('0' + futureTime.getHours()).slice(-2);
      const minutes = ('0' + futureTime.getMinutes()).slice(-2);

      // Возвращаем отформатированную строку времени
      return hours + ':' + minutes;
    }
  },
  methods: {
    goToDocument(name) {
      this.$router.push('/documents/' + name);
    },
    goToGetLoan() {
      this.$router.push('/how-to-get-loan');
    },
    goToReturn() {
      this.$router.push('/how-to-return');
    },
    goToReviews() {
      this.$router.push('/reviews');
    },
    goToDocuments() {
      this.$router.push('/documents-page');
    },
    goToCompanyPage() {
      this.$router.push('/about-company');
    },
    nextReview() {
      this.currentIndex = (this.currentIndex + 1) % this.reviews.length;
    },
    previousReview() {
      this.currentIndex = (this.currentIndex - 1 + this.reviews.length) % this.reviews.length;
    },
    renderTime() {
      // Get the current time and add 10 minutes to it
      var currentTime = new Date();
      var futureTime = new Date(currentTime.getTime() + 10 * 60 * 1000);
      // Format the time as HH:MM
      var formattedTime = futureTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      // Update each element with the class 'timeLabel' with the formatted time
      $('.timelabel').text(formattedTime);
    },
    changeDate(date) {
      var Year = date.getFullYear();
      var Month = date.getMonth();
      var Day = date.getDate();

      var fMonth;
      // Преобразуем месяца
      switch (Month) {
        case 0:
          fMonth = "января";
          break;
        case 1:
          fMonth = "февраля";
          break;
        case 2:
          fMonth = "марта";
          break;
        case 3:
          fMonth = "апреля";
          break;
        case 4:
          fMonth = "мая";
          break;
        case 5:
          fMonth = "июня";
          break;
        case 6:
          fMonth = "июля";
          break;
        case 7:
          fMonth = "августа";
          break;
        case 8:
          fMonth = "сентября";
          break;
        case 9:
          fMonth = "октября";
          break;
        case 10:
          fMonth = "ноября";
          break;
        case 11:
          fMonth = "декабря";
          break;
      }
      return `${Day} ${fMonth} ${Year}`;
    },
    jqueryLoaded() {
      // создание бегунков
      this.slider = document.getElementById("slider-sum"); // бегунок суммы
      this.slider2 = document.getElementById("slider-period"); // бегунок дней

      let sumBlock = document.getElementById("calculator_sum");
      let dateBlock = document.getElementById("calculator_date");
      let salePriceBlock = document.getElementById("sale-price");
      let priceBlock = document.getElementById("price");
      let dateFinishBlock = document.getElementById("date");

      noUiSlider.create(this.slider, {
        start: 10000, // значение бегунка при загрузке
        connect: "lower",
        range: {
          min: 5000, // минимальное значение бегунка суммы
          max: 30000, // максимальное значение бегунка суммы
        },
        step:1000,
      });

      noUiSlider.create(this.slider2, {
        start: 91, // значение бегунка при загрузке
        connect: "lower",
        range: {
          min: 91, // минимальное значение бегунка дней
          max: 365, // максимальное значение бегунка дней
        },
      });

      // расчет даты и суммы при загрузке страницы
      let startSum = Math.round(this.slider.noUiSlider.get()); // получаем стартовое значение суммы
      let startDays = Math.round(this.slider2.noUiSlider.get()); // получаем стартовое значение дней
      let currentDate = new Date();
      currentDate.setDate(currentDate.getDate() + startDays);

      // формула расчёта перечеркнутой суммы
      let salePrice = Math.round((startSum * 0.1 + startSum) * 1.1);

      dateFinishBlock.innerHTML = this.changeDate(currentDate);
      sumBlock.innerHTML = `${startSum.toLocaleString()}`;
      priceBlock.innerHTML = `${startSum.toLocaleString()}`;
      salePriceBlock.innerHTML = `${salePrice}`;

      // ивенты бегунков
      this.slider.noUiSlider.on("slide", function (values, handle) {
        let dataValue = Math.round(values[handle]);
        // формула расчёта перечеркнутой суммы
        let salePrice = Math.round((dataValue * 0.1 + dataValue) * 1.1);
        sumBlock.innerHTML = `${dataValue.toLocaleString()}`;
        priceBlock.innerHTML = `${dataValue.toLocaleString()}`;
        salePriceBlock.innerHTML = `${salePrice}`;
      });

      this.slider2.noUiSlider.on("slide", (values, handle) => {
        let dataValue = Math.round(values[handle]);
        let date = new Date();
        date.setDate(date.getDate() + dataValue);
        dateBlock.innerHTML = `${dataValue}`;
        dateFinishBlock.innerHTML = this.changeDate(date);
      });
    },
    clickOpenLabel1() {
      window.localStorage.setItem('sum', this.slider.noUiSlider.get());
      window.localStorage.setItem('date', this.slider2.noUiSlider.get());
      this.$router.push('/login');
    },
    reloadComponent() {
      this.$router.go(0);
    },
    goToLogin() {
      this.$router.push('/login');
    },
    goToReg() {
      this.$router.push('/registration-step1');
    },
    loadScripts() {
      // Удаляем старые скрипты
      this.removeOldScripts();

      // Подключаем jQuery
      loadjs(
          "https://d3e54v103j8qbb.cloudfront.net/js/jquery-3.5.1.min.dc5e7f18c8.js?site=652921c910bae02d8870dddf",
          {
            success: () => {
              console.log('jQuery loaded');

              // Подключаем Webflow
              loadjs('./js/webflow.js', {
                success: () => {
                  console.log('Webflow loaded');
                  this.initAccordions();
                  this.jqueryLoaded();

                  // Call the function initially to set the time
                  this.renderTime();
                  // Set an interval to update the time every 10 minutes
                  setInterval(this.renderTime, 1000);
                },
                error: () => {
                  console.error('Failed to load Webflow');
                }
              });

              // Подключаем аккордеоны
              const scriptUrl = 'https://cdn.jsdelivr.net/npm/@finsweet/attributes-accordion@1/accordion.js';
              const script = document.createElement('script');
              script.async = true;
              script.src = scriptUrl;
              document.head.appendChild(script);
              script.onload = () => {
                console.log('Accordion script loaded');
                this.initAccordions();
              };
            },
            error: () => {
              console.error('Failed to load jQuery');
            }
          }
      );
    },
    removeOldScripts() {
      const scripts = document.querySelectorAll('script[src*="accordion.js"], script[src*="jquery-3.5.1.min.dc5e7f18c8.js"], script[src*="webflow.js"]');
      scripts.forEach(script => {
        script.parentNode.removeChild(script);
      });
    },

    initAccordions() {
      if (typeof window.fsAttributes !== 'undefined' && window.fsAttributes.accordion) {
        window.fsAttributes.accordion.init();
      } else {
        console.log('Accordion init function not found');
      }
    }
  },
  mounted() {
    this.loadScripts();
  },

  activated() {
    this.loadScripts();
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      window.scrollTo(0, 0);
    });
  },
};
</script>

<style>
</style>
